<template>
  <div class="page">
    <h1>home</h1>
    <div>
      <h2>登录/授权</h2>
      <button @click="auth">登录</button>
      <button v-if="isWechat" @click="unbind">取消绑定</button>
    </div>
  </div>
</template>

<script>
import { httpUser } from "../../scripts/network";
import { login, unbind } from "../../scripts/auth";
export default {
  name: "home",
  data() {
    return {
      phone: "1",
      isWechat: this.$store.state.isWechat
    };
  },
  methods: {
    async getGraphCode() {
      if (this.phone) {
        this.cancelValidate && this.cancelValidate();
        const params = {
          param: {
            "para.tag": this.phone,
            "para.width": 120,
            "para.height": 45
          }
        };
        let ret;
        try {
          ret = await httpUser("/User/GetImgValidCode", params, cancel => {
            this.cancelValidate = cancel;
          });
        } catch (error) {
          console.error("----", error);
        }
        if (ret && ret.Status) {
          this.image = ret.Data;
        }
      }
    },
    auth() {
      login(this.$store, this.$router);
    },
    unbind() {
      unbind();
    },

    test() {
      let { path, query } = this.$router.history.current;
      this.$router.replace({
        path: "/auth",
        query: {
          redirect: JSON.stringify({
            path: path,
            query: query
          })
        }
      });
      // this.getGraphCode()
      // this.$router.push({path:'/mine'})
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  margin: 16px 0px 8px 8px;
}
h2 + * {
  margin-left: 16px;
}
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

button {
  background: #42b983;
  border: none;
  height: 36px;
  line-height: 36px;
  padding: 0px 16px;
  border-radius: 8px;
  color: white;
}
button + button{
  margin-left: 8px;
}

</style>
